import loadable from '@loadable/component'

export const MarketingTag = loadable(() => import('./MarketingTag'))
export const MarketingTags = loadable(() => import('./MarketingTags'))

export type {
  MarketingTagProps,
  MarketingTagPropsNoLink,
  MarketingProps,
  MarketingTagRenderLinkProps
} from './MarketingTag'
export type { MarketingTagsProps } from './MarketingTags'
